import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect, useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { ErrorAlert } from 'components/atoms/Alert-message';
import HomeActionItem from 'components/HomePage/HomeActionItem';
import imgCreateECR from 'components/images/Create PECR.svg';
import imgPECRList from 'components/images/PECR List.svg';
import PageHeader from 'components/shared/PageHeader';
import { pecrData } from 'reducers/pecr-info/slice';

// P/ECR Home Page Component
function HomePage({ userInfo, errorInAPI }) {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const disabledButton =
    userInfo?.active?.toString() !== '1' ||
    userInfo?.userId?.toString() === '0' ||
    userInfo?.userId === null;
  const navigateToCreatePecr = () => {
    navigate('/Overview');
    dispatch(pecrData({ key: 'insertId', value: null }));
    dispatch(pecrData({ key: 'pecrId', value: null }));
  };
  const navigatePecrList = () => {
    navigate({
      pathname: '/List',
      search: location.search,
    });
  };
  const navigateTodoList = () => {
    navigate('/MyToDo');
  };
  const navigateMyPecr = () => {
    navigate('/MyPecr');
  };

  if (errorInAPI.hasErrorOccured) {
    return <ErrorAlert message={errorInAPI.message} />;
  }

  return (
    <div className="min-h-[calc(100vh-80px)]">
      <PageHeader title={`Welcome, ${userInfo.name || 'User'}`} />

      <div className="mx-auto mt-4 max-w-7xl px-8 pb-12">
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4">
          <HomeActionItem
            image={imgCreateECR}
            title={t('PECR')}
            description={t('About_PECR')}
            buttonTitle={t('Create_New_PECR')}
            to={navigateToCreatePecr}
            disabled={disabledButton}
          />
          <HomeActionItem
            image={imgPECRList}
            title={t('PECR_List')}
            description={t('List_of_open_PECR')}
            buttonTitle={t('PECR_List')}
            to={navigatePecrList}
            disabled={disabledButton}
          />
          <HomeActionItem
            image={imgPECRList}
            title={t('PECR_Tasks')}
            description={t('List_of_actions')}
            buttonTitle={t('My_to_do_list')}
            to={navigateTodoList}
            disabled={disabledButton}
          />
          <HomeActionItem
            image={imgPECRList}
            title={t('PECR_List')}
            description={t('List_of_ECR_I_have_created')}
            buttonTitle={t('My_PECR')}
            to={navigateMyPecr}
            disabled={disabledButton}
          />
        </div>
      </div>
    </div>
  );
}

HomePage.propTypes = {
  userInfo: PropTypes.shape({
    active: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    firstName: PropTypes.string,
  }),
  errorInAPI: PropTypes.shape({
    hasErrorOccured: PropTypes.bool,
    message: PropTypes.string,
  }),
};

const mapStateToProps = (state = {}) => {
  return {
    overview: state.pecrInfo.createPecr,
    userInfo: state.userInfo,
    errorInAPI: state.errorNotification,
  };
};

export default connect(mapStateToProps, null)(HomePage);
